module.exports = __webpack_public_path__ + "static/media/12C_Diesel.877209f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/tco/assets/12C_Diesel.jpg
// module id = 1481
// module chunks = 0